import React from 'react';
import { styled } from '@mui/material';

import { Avatar, ProgressBar, Stack, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const IndividualAnalytics = ({ students = [], stats = {}, ...rest }) => {
    return (
        <RootStack {...rest} spacing={4}>
            {[...students]
                ?.sort(
                    (a, b) =>
                        stats?.[b.owner_account_id]?.completedPoints - stats?.[a.owner_account_id]?.completedPoints
                )
                .map((student) => {
                    const name = getUserPreferredFullName(student);
                    return (
                        <Stack key={student.owner_account_id} alignItems={'center'} direction={'row'} spacing={2}>
                            <Avatar size={'small'} user={student} />
                            <DataStack spacing={1}>
                                <Text noWrap variant={'p2'}>
                                    {name}
                                </Text>
                                <ProgressBar
                                    aria-label={'task completion progress'}
                                    value={stats?.[student.owner_account_id]?.percentage}
                                />
                                <Text color={'light'} noWrap variant={'p3'}>
                                    {stats?.[student.owner_account_id]?.completedPoints}/
                                    {stats?.[student.owner_account_id]?.totalPoints} Task Points
                                </Text>
                            </DataStack>
                            <PercentageText align={'right'} variant={'p2'}>
                                {Math.round(stats?.[student.owner_account_id]?.percentage)}%
                            </PercentageText>
                        </Stack>
                    );
                })}
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme }) => {
    return {
        marginTop: theme.spacing(3),
    };
});

const DataStack = styled(Stack)(() => {
    return {
        flex: 1,
        width: 0,
    };
});

const PercentageText = styled(Text)(() => {
    return {
        width: '2.125rem',
    };
});

export default IndividualAnalytics;
